import React from "react";

import useBook from "../../hooks/useBook";

import ArchiveCanvas from "../../shared_comp/ArchiveCanvas";
import SectionTitle from "../../shared_comp/SectionTitle";
import MainCanvas from "../../shared_comp/MainCanvas";
import Working from "../../shared_comp/Working";

const EtcMain = () => {
  const docList = useBook.getBookList("etc");
  console.log(docList);

  return (
    <ArchiveCanvas>
      <SectionTitle title="참고자료 / 기타" />
      <MainCanvas>
        <Working />
      </MainCanvas>
    </ArchiveCanvas>
  );
};
export default EtcMain;
